<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2021-04-20 14:26:21
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-09-06 15:12:16
 * @FilePath: /uedc-material-system-front/src/views/admin/template/template-public-admin.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="c-a-tpl-public">
    <template-list
      v-if="!open"
      scrollEl=".admin-template-public"
      :projectId="$store.state.app.loginUser.publicProject.id"
      @open="open = true"
    ></template-list>
    <category-manage v-model="open"></category-manage>
  </div>
</template>

<script>
import routerMixin from '@/mixins/router-mixin.js'
import templateList from '../../components/template/template-list-index'
import CategoryManage from '../../components/template/category-manage.vue'
export default {
  components: {
    templateList,
    CategoryManage
  },
  mixins: [routerMixin],
  data () {
    return {
      open: false
    }
  },
  beforeDestroy () {
    this.open = false
  },
  created () {}
}
</script>
<style>
.c-a-tpl-public {

}
</style>
